export default {
    alexa: {
        tcl_assitant: "TCL Assistant",
        active_code_hint: "请输入激活码",
        active_code_placeholder: "激活码",
        active_code_message: "在TCL电视上，进入",
        active_code_message_path: "Settings/System/Amazon Alexa/Obtain code,",
        active_code_message_part2: "将获取的激活码输入到下边输入框中。",
        active_code_error_null: "激活码不能为空",
        active_code_error_number: "请输入数字",
        active_code_error_bits: "请输入六位数",
        active_code_validate: "校验",
        active_code_message_wrong: "激活码错误或者过期，请重新获取!",
        active_code_message_exception: "操作超时，请重试！",
        check_agreements_message: "使用 TCL Assistant 请同意以上条款",
        agreements: [
            "我同意 TCL 记录我的语音指令",
            "我同意 TCL ",
            "."
        ],
        privacy_policy: "隐私政策",
       
        grant_hint: "请授权 TCL 进行操作",
        grant_message_success: "授权成功 !",
        grant_message_fail: "授权失败，请重新输入激活码",
        grant_allow: "允许",
       
        console_welcome_prompt: "Welcome To TCL Alexa Console",
        empty_message: "",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/zh-cn.js
// module id = null
// module chunks = 